export var CancelRequestType;
(function (CancelRequestType) {
    CancelRequestType["Schedule"] = "Schedule";
    CancelRequestType["Now"] = "Now";
})(CancelRequestType || (CancelRequestType = {}));
export var RefundRequestType;
(function (RefundRequestType) {
    RefundRequestType["full"] = "full";
    RefundRequestType["prorated"] = "prorated";
    RefundRequestType["custom"] = "custom";
})(RefundRequestType || (RefundRequestType = {}));
export var FormFields;
(function (FormFields) {
    FormFields["transaction"] = "transaction";
    FormFields["refundRequestType"] = "refundRequestType";
    FormFields["customAmount"] = "customAmount";
    FormFields["cancelSubscription"] = "cancelSubscription";
    FormFields["cancelRequestType"] = "cancelRequestType";
})(FormFields || (FormFields = {}));
